/*
 * Custom JavaScript
 * ===========================================================================
 *
 * Use this file to add your own custom JavaScript code.
 *
 * This file is loaded at the end of the body with the 'defer' attribute,
 * which means it will execute after the HTML document has been parsed.
 *
 * Tips:
 * - The DOM is ready when this script runs (no need for DOMContentLoaded)
 * - You can use Shopify's global objects like:
 *   - window.Shopify - Shopify global object with shop info
 *   - window.routes - Cart and search URLs
 *   - window.cartStrings - Cart-related translation strings
 *   - window.variantStrings - Product variant translation strings
 *
 * - The theme uses a pub/sub pattern for events. You can subscribe to events:
 *   - subscribe(PUB_SUB_EVENTS.cartUpdate, callback) - Cart updates
 *   - subscribe(PUB_SUB_EVENTS.quantityUpdate, callback) - Quantity changes
 *
 * - Common DOM queries:
 *   - document.querySelector('.selector') - Get single element
 *   - document.querySelectorAll('.selector') - Get all matching elements
 *
 * ===========================================================================
 */

/* Add your custom JavaScript below this line */

/* ============================================================
   DOTS FICHE PRODUIT — custom.js
   Colle ce contenu dans assets/custom.js

   Contexte : la fiche produit utilise data-thumbnail-navigation="true"
   ce qui désactive les dots natifs dans slider.js.
   Ce script injecte des dots ronds fonctionnels sous le slider
   principal de la fiche produit uniquement.

   Les autres sliders (liste collections, etc.) utilisent déjà
   les dots natifs de slider.js, stylisés via custom.css.
   ============================================================ */

(function () {

  function initProductDots(sliderElement) {
    if (sliderElement.dataset.productDotsBuilt) return;
    if (sliderElement.dataset.thumbnailNavigation !== 'true') return;

    var keenSlider = sliderElement.querySelector('.keen-slider');
    if (!keenSlider) return;

    var slides = keenSlider.querySelectorAll('.keen-slider__slide');
    if (slides.length < 2) return;

    // Détermine si on doit masquer sur desktop (quand thumbnails visibles)
    var hideDesktop = sliderElement.querySelector('.thumbnail-slider') !== null;

    // Crée le conteneur de dots
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'product-dots' + (hideDesktop ? ' product-dots--hide-desktop' : '');
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Navigation images produit');

    slides.forEach(function (_, i) {
      var btn = document.createElement('button');
      btn.className = 'product-dots__dot' + (i === 0 ? ' product-dots__dot--active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', 'Image ' + (i + 1));
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.dataset.index = i;

      btn.addEventListener('click', function () {
        var idx = parseInt(this.dataset.index);
        // Utilise l'instance Keen Slider stockée sur le slider-element
        if (sliderElement.sliderInstance) {
          sliderElement.sliderInstance.moveToIdx(idx);
        }
      });

      dotsWrap.appendChild(btn);
    });

    // Insère les dots après la navigation wrapper
    var navWrapper = sliderElement.querySelector('.slider__navigation');
    if (navWrapper) {
      navWrapper.insertAdjacentElement('afterend', dotsWrap);
    } else {
      sliderElement.appendChild(dotsWrap);
    }

    sliderElement.dataset.productDotsBuilt = '1';
    sliderElement._productDotsWrap = dotsWrap;

    // Attend que sliderInstance soit disponible (initialisé dans slider.js)
    waitForInstance(sliderElement);
  }

  function waitForInstance(sliderElement) {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (sliderElement.sliderInstance) {
        clearInterval(interval);
        bindDotsToInstance(sliderElement);
        return;
      }
      if (attempts > 40) { // 2 secondes max
        clearInterval(interval);
      }
    }, 50);
  }

  function bindDotsToInstance(sliderElement) {
    var instance = sliderElement.sliderInstance;
    var dotsWrap = sliderElement._productDotsWrap;
    if (!instance || !dotsWrap) return;

    // Sync dots à chaque changement de slide
    instance.on('slideChanged', function () {
      var idx = instance.track.details.rel;
      updateDots(dotsWrap, idx);
    });

    // Sync initial
    updateDots(dotsWrap, 0);

    // Sync depuis l'événement variantMediaUpdate (changement couleur/taille)
    window.addEventListener('variantMediaUpdate', function () {
      setTimeout(function () {
        if (instance.track && instance.track.details) {
          updateDots(dotsWrap, instance.track.details.rel);
        }
      }, 150);
    });
  }

  function updateDots(dotsWrap, activeIdx) {
    dotsWrap.querySelectorAll('.product-dots__dot').forEach(function (dot, i) {
      var active = i === activeIdx;
      dot.classList.toggle('product-dots__dot--active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  // Initialise tous les slider-element de fiche produit présents au chargement
  function init() {
    document.querySelectorAll('slider-element[data-thumbnail-navigation="true"]').forEach(function (el) {
      initProductDots(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Réinitialise après rechargement de section (éditeur Shopify)
  document.addEventListener('shopify:section:load', init);

  // Observer pour les sliders chargés dynamiquement
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'SLIDER-ELEMENT' && node.dataset.thumbnailNavigation === 'true') {
          initProductDots(node);
        }
        node.querySelectorAll && node.querySelectorAll('slider-element[data-thumbnail-navigation="true"]').forEach(initProductDots);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();